module.exports = __webpack_public_path__ + "img/utilitylight_parked.ae687d32.svg";